import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { ZoneService } from 'src/app/core/services/zone.service';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ZoneComponent implements OnInit {

  zoneForm!: FormGroup;
  zoneId: number | null = null;
  estModeEdition = false;

  textHeading = 'Zone';
  textBody = 'Enregistrer une Zone';

  zones: any = undefined;
  villes: any[] = [];

  roleOptions: { label: string, value: string }[] = [];

  chargement = false;
  userCreated: boolean = true;



  menuSidebarActive:boolean=false;
  myfunction(){
    if(this.menuSidebarActive==false){
      this.menuSidebarActive=true;
    }
    else {
      this.menuSidebarActive=false;
    }
  }

  hide = true;

menuShortcutActive:boolean=false;
shortmenu(){
  if(this.menuShortcutActive==false){
    this.menuShortcutActive=true;
    this.emailShortcutActive=false;
    this.notifyShortcutActive=false;
    this.langShortcutActive=false;
    this.proShortcutActive=false;
  }
  else {
    this.menuShortcutActive=false;
  }
}

notifyShortcutActive:boolean=false;
notifydropdown(){
  if(this.notifyShortcutActive==false){
    this.menuShortcutActive=false;
    this.emailShortcutActive=false;
    this.notifyShortcutActive=true;
    this.langShortcutActive=false;
    this.proShortcutActive=false;
  }
  else {
    this.notifyShortcutActive=false;
  }
}

emailShortcutActive:boolean=false;
emaildropdown(){
  if(this.emailShortcutActive==false){
    this.menuShortcutActive=false;
    this.emailShortcutActive=true;
    this.notifyShortcutActive=false;
    this.langShortcutActive=false;
    this.proShortcutActive=false;
  }
  else {
    this.emailShortcutActive=false;

  }
}

langShortcutActive:boolean=false;
langdropdown(){
  if(this.langShortcutActive==false){
    this.menuShortcutActive=false;
    this.emailShortcutActive=false;
    this.notifyShortcutActive=false;
    this.langShortcutActive=true;
    this.proShortcutActive=false;
  }
  else {
    this.langShortcutActive=false;

  }
}

proShortcutActive:boolean=false;
prodropdown(){
  if(this.proShortcutActive==false){
    this.menuShortcutActive=false;
    this.emailShortcutActive=false;
    this.notifyShortcutActive=false;
    this.langShortcutActive=false;
    this.proShortcutActive=true;
  }
  else {
    this.proShortcutActive=false;

  }
}

  constructor(
    private fb: FormBuilder,
    public zonesService: ZoneService,
    private messageService: MessageService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {
    this.zoneForm = this.fb.group({
      id: [null],
      nom: ['', Validators.required],
      description: [''],
      villeId: [null]
    });
  }

  ngOnInit(): void {
    this.http.get<any[]>(`${environment.apiurl}villes`).subscribe({
      next: (data) => this.villes = Array.isArray(data) ? data : [],
      error: () => {}
    });
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.zoneId = +params['id'];
        this.estModeEdition = false;
        this.textBody = 'Afficher une Zone';
        this.chargerZone(this.zoneId);
      }
    });
  }

  chargerZone(id: number): void {
    this.chargement = true;
    this.zonesService.obtenirZoneParId(id).subscribe(
      (zone) => {
        this.chargement = false;
        this.zoneForm.patchValue({
          id: zone.id,
          nom: zone.nom,
          description: zone.description,
          villeId: zone.villeId ?? null
        });
      },
      () => {
        this.chargement = false;
        this.toastService.erreur('Impossible de charger la zone');
      }
    );
  }



  onSubmit() {
    if (this.zoneForm.invalid) {
      this.zoneForm.markAllAsTouched();
      return;
    }

    this.chargement = true;

    if (this.estModeEdition) {
      this.zonesService.modifierZone(this.zoneForm.value).subscribe(
        () => {
          this.chargement = false;
          this.toastService.succes('Zone modifiée avec succès');
          this.router.navigate(['zone/lister']);
        },
        (erreur) => {
          this.chargement = false;
          this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
        }
      );
    } else {
      this.zonesService.enregistrerZone(this.zoneForm.value).subscribe(
        () => {
          this.chargement = false;
          this.toastService.succes('Zone enregistrée avec succès');
          this.router.navigate(['zone/lister']);
        },
        (erreur) => {
          this.chargement = false;
          this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
        }
      );
    }
  }


  nomVille(villeId: number | null | undefined): string {
    if (!villeId) return '—';
    const v = this.villes.find(x => x.id === Number(villeId));
    return v ? v.nom : '—';
  }
}

